import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';

const NewImage = ({ currentUser, showButton, socket }) => {

    const [show, setShow] = useState(false);

    const [id, setId] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loading) {
            if (window.location.href.includes('repeater/')) {
                setId(window.location.href.split('repeater/')[1]);
                setLoading(false);
            } else {
                setId('0');
                setLoading(false);
            }
        }
    }, [loading])


    const handleClose = () => {
        setShow(false);
    }

    const [file, setFile] = useState(null);

    const handleFile = e => {
        setFile(e.target.files[0]);
    }

    const handleSubmit = () => {
        // file type is only image.
        if (/^image\//.test(file.type)) {
            let payload = {
                id: currentUser.user._id,
                file,
                type: id,
                ip: localStorage.getItem('ip'),
                jwt: localStorage.getItem('auth_token')
            }
            socket.emit('store image', payload);
            setShow(false);
        } else {
            console.warn("You can only upload images.");
        }
    };

    return (
        <>
            {((currentUser.isAuthenticated && !window.location.href.includes('repeater')) && (currentUser.user.isAdmin > 8 || currentUser.user.isAdmin.toString() === id) && currentUser.adminSettings) ? (
                <IconButton
                    onClick={() => { setShow(true); setLoading(true); }}
                    sx={{ position: 'absolute', top: 8, left: 8, color: 'white', bgcolor: 'rgba(0,0,0,0.4)', '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' } }}
                    size="small"
                >
                    <EditIcon fontSize="small" />
                </IconButton>
            ) : ((currentUser.isAuthenticated && window.location.href.includes('repeater') && showButton) && (currentUser.user.isAdmin > 8 || currentUser.user.isAdmin.toString() === id) && currentUser.adminSettings) && (
                <Button variant="outlined" sx={{ mt: 2 }} onClick={() => { setShow(true); setLoading(true); }}>
                    Change Banner
                </Button>
            )}
            <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle>New Image</DialogTitle>
                <DialogContent>
                    <Button variant="outlined" component="label" sx={{ mt: 1 }}>
                        Choose File
                        <input type="file" hidden onChange={handleFile} />
                    </Button>
                    {file && <Box sx={{ mt: 1 }}>{file.name}</Box>}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="contained" onClick={handleSubmit}>
                        Upload
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default NewImage;
